import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import PayPopup from "../shopCart/PayPopup";
import { globalFileIcon } from "../../../../axiosInstance";
import { GetProductsToOrder } from "../../../server/ProductToOrder";
import { CollectSiteProductSetOrder } from "../../../server/CollectSite";
import { orderPerCustomer } from "../../../server/Order";
import { useSelector, useDispatch } from "react-redux";
import PopUp from "../../containers/PopUp";

const UserHistory = ({ name, setProductPopUp, setSelectedProd }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [items, setItems] = useState([]);
  const toShow = 7;
  const [currentPage, setCurrentPage] = useState(1);
  const [orderIdPay, setOrderPay] = useState(null);
  const [HaveToPay, setHaveToPay] = useState(null);

  const PayNow = (orderId, sum) => {
    setOrderPay(orderId);
    setHaveToPay(sum);
  };

  const closePayPopup = () => {
    setOrderPay(null);
  };

  const CloseProduct = (orderId) => {
    const orders = [...items];
    const selectOrderIndex = orders.findIndex((x) => x.id === orderId);
    const selectOrder = orders[selectOrderIndex];
    selectOrder.ProductsShow = false;
    setItems(orders);
  };
  const getProductToOrder = (orderId) => {
    const orders = items.map((o) => ({ ...o }));

    const selectOrderIndex = orders.findIndex((x) => x.id === orderId);
    const selectOrder = orders[selectOrderIndex];
    selectOrder.ProductsShow = true;
    if (!selectOrder.Products) {
      console.log(
        "Fetching products for order:",
        orderId,
        "user StationId:",
        user.StationId,
      );
      GetProductsToOrder(orderId, user.StationId)
        .then((x) => {
          // selectOrder.Products = x.data.orderItems;
          selectOrder.Products = x.data.orderItems.map((item) => ({
            Description: item.product?.name || "מוצר לא נמצא",
            quantity: item.quantity,
            totalPrice: item.totalPrice || item.price * item.quantity,
            Price: item.price,
            ProductMkt: 0,
            Id: item.productId,
          }));

          const productsSum = selectOrder.totalSum;

          const delivery = selectOrder.deliveryPrice || 0;
          const coupon = selectOrder.couponDiscount || 0;

          selectOrder.finalSum = productsSum + delivery - coupon;

          orders[selectOrderIndex] = { ...selectOrder };
          setItems(orders);
        })
        .catch(() => console.log("error"));
    } else {
      const productsSum = selectOrder.totalSum;

      const delivery = selectOrder.deliveryPrice || 0;
      const coupon = selectOrder.couponDiscount || 0;

      selectOrder.finalSum = productsSum + delivery - coupon;

      setItems(orders);
    }
  };

  const setPage = (currentPage) => {
    setCurrentPage(currentPage);
    window.scrollTo(0, 0);
  };
  const getItems = useCallback(() => {
    orderPerCustomer(user.Id, user.StationId)
      .then((x) => {
        console.log("הזמנות מהשרת:", x.data);
        setItems(x.data.orders);
        const orders = x.data.orders.map((o) => ({
          ...o,
          finalSum:
            (o.totalSum || 0) +
            (o.deliveryPrice || 0) -
            (o.couponDiscount || 0),
        }));
        setItems(orders);
      })
      .catch(() => console.log("error"));
  }, [user]);

  useEffect(() => {
    getItems();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }, [getItems]);

  // const getStatusClass = (status) => {
  //   switch(status) {
  //     case 'הזמנה סגורה': return 'status-ready';
  //     case 'בליקוט רובוט': return 'status-demand';
  //     case 'ממתין לליקוט':
  //     case 'hamazon-created': return 'status-done';
  //     default: return 'status-default';
  //   }
  // };
  const getStatusClass = (status) => {
    if (!status) return "status-default";

    const s = status.toLowerCase();
    if (s.includes("closed")) return "status-ready";
    if (s.includes("demand")) return "status-demand";
    if (s.includes("created")) return "status-done";
    if (s.includes("pending_picking")) return "status-done";
    return "status-default";
  };

  const getStatusText = (status) => {
    if (!status) return "סטטוס לא ידוע";
    const s = status.trim().toLowerCase();
    if (s.includes("created")) return "ממתין לליקוט";
    if (s.includes("pending_picking")) return "ממתין לליקוט";
    if (s.includes("closed")) return "הזמנה סגורה";
    if (s.includes("demand")) return "בליקוט רובוט";

    return s;
  };

  let pagination = [];

  if (Array.isArray(items) && items.length > 0 && toShow > 0) {
    pagination = [...Array(Math.ceil(items.length / toShow)).keys()];
  }
  console.log("user:", user);
  return (
    <div className="user-history" dir="rtl">
      {orderIdPay ? (
        <PayPopup
          closePayPopup={closePayPopup}
          orderId={orderIdPay}
          SumPay={HaveToPay}
          tranmode={false}
        />
      ) : null}
      <p className="user-history-header">
        {" "}
        <img
          loading="lazy"
          src={globalFileIcon + "history_order.svg"}
          alt="history_order"
        />
        ההזמנות של {name}
      </p>
      <div className="orders-grid">
        {!items.length ? <h1 className="no-products">אין הזמנות</h1> : null}
        {items.map((element, index) => {
          console.log("order element:", element);
          return index < toShow * currentPage &&
            index >= (currentPage - 1) * toShow ? (
            <div key={index} className="order-card">
              <div className="order-header">
                <div>מס' הזמנה: {element.id}</div>

                <div className="price-details">
                  {element.couponDiscount ? (
                    <>
                      <p className="price original-price">
                        ₪
                        {(element.finalSum + element.couponDiscount).toFixed(2)}
                      </p>

                      <p className="price sale">
                        ₪{element.finalSum.toFixed(2)}
                      </p>
                    </>
                  ) : (
                    <p className="price">₪{element.finalSum.toFixed(2)}</p>
                  )}
                </div>
              </div>
              <div className="order-info">
                <div className="order-info-header">
                  <span
                    className={`status-badge ${getStatusClass(
                      element.tenantStatus,
                    )}`}
                  >
                    {getStatusText(element.tenantStatus)}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-icon">👤</span>
                  <span>
                    {console.log("name:", element.name, element.CustomerName)}
                    {element.name ? element.name : element.CustomerName}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-icon">📍</span>
                  <span className="location-text">
                    {element.address ? element.address : element.FullAddress}
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-icon">🕒</span>
                  <span>
                    {moment(element.created).format("DD.MM.YY HH:mm")}
                  </span>
                </div>
                {element.Comment && (
                  <div className="info-row">
                    <span className="info-icon">✏️</span>
                    <span className="comment-text">{element.Comment}</span>
                  </div>
                )}
                {element.couponDiscount && (
                  <div className="info-row">
                    <span className="info-icon">הנחת קופון:</span>
                    <span className="comment-text">
                      ₪{element.couponDiscount}
                    </span>
                  </div>
                )}
                {element.payment?.lastFourDigits && (
                  <div className="info-row">
                    <span className="info-icon">💳</span>
                    <span>כרטיס: ****{element.payment.lastFourDigits}</span>
                  </div>
                )}
                {element.PaymentDateTime && (
                  <div className="info-row">
                    <span className="info-icon">📅</span>
                    <span>
                      תאריך תשלום:{" "}
                      {moment(element.PaymentDateTime).format("DD.MM.YY")}
                    </span>
                  </div>
                )}
              </div>
              <div className="order-actions">
                {element.HaveToPay && element.CanPay ? (
                  <div className="wrap">
                    <button
                      className="btn"
                      onClick={() => PayNow(element.id, element.HaveToPay)}
                    >
                      לתשלום &gt;
                    </button>
                    <p>{element.HaveToPay}</p>
                  </div>
                ) : null}
                <button
                  className="btn"
                  onClick={() =>
                    dispatch(CollectSiteProductSetOrder(element.OrderId))
                  }
                >
                  העתק לסל
                </button>
                <button
                  className="action-button view-order"
                  onClick={() => getProductToOrder(element.id)}
                >
                  הצגת הזמנה
                </button>
              </div>
              {element.ProductsShow && element && (
                <PopUp
                  width="700px"
                  close={() => CloseProduct(element.id)}
                  className="order-popup"
                >
                  <div className="modal-body">
                    <h3 className="header">פריטים בהזמנה מס׳ {element.id}:</h3>
                    <div className="order-table-container">
                      <table className="order-table">
                        <thead>
                          <tr>
                            <th>מוצר</th>
                            <th>כמות</th>
                            <th>מחיר יח'</th>
                            <th>סה"כ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {element.Products &&
                            element.Products.map((el, idx) => {
                              if (idx === 0 && el.ProductMkt === 999)
                                // delivery product
                                return null;
                              return (
                                <tr key={`${el.Id}-${idx}`}>
                                  <td
                                    className="product-details"
                                    onClick={() => {
                                      setSelectedProd(el);
                                      setProductPopUp(true);
                                    }}
                                  >
                                    <p className="description">
                                      {el.Description}
                                    </p>
                                  </td>
                                  <td className="quantity">{el.quantity}</td>
                                  <td className="price">
                                    ₪{el.totalPrice / el.quantity}
                                  </td>
                                  <td className="total">₪{el.totalPrice}</td>
                                </tr>
                              );
                            })}
                          <tr className="delivery">
                            <td>משלוח</td>
                            <td></td>
                            <td></td>
                            <td>
                              ₪
                              {element.Products?.[0]?.ProductMkt === 999
                                ? element.Products?.[0]?.Price
                                : element.deliveryPrice}
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          {element.couponDiscount && (
                            <tr className="delivery coupon-row">
                              <td>הנחת קופון</td>
                              <td></td>
                              <td></td>
                              <td style={{ color: "red" }}>
                                -₪{element.couponDiscount}
                              </td>
                            </tr>
                          )}

                          <tr>
                            <td colSpan="2">
                              סה"כ:{" "}
                              {element.Products?.[0]?.ProductMkt === 999
                                ? (element.Products?.length || 1) - 1
                                : element.Products?.length || 0}{" "}
                              פריטים
                            </td>
                            <td />
                            <td className="final-total">
                              ₪{element.finalSum ?? element.PaymentOrg}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <div className="modal-actions">
                      <button
                        onClick={() => CloseProduct(element.id)}
                        className="button-secondary"
                      >
                        סגור
                      </button>
                      <button
                        className="button-primary"
                        onClick={() =>
                          dispatch(CollectSiteProductSetOrder(element.id))
                        }
                      >
                        העתק לסל
                      </button>
                    </div>
                  </div>
                </PopUp>
              )}
            </div>
          ) : null;
        })}
      </div>

      {pagination.length > 1 ? (
        <div className="pagination">
          <ul>
            {currentPage > 1 ? (
              <li onClick={() => setPage(currentPage - 1)}>
                <img
                  loading="lazy"
                  src={globalFileIcon + "right-arrow.svg"}
                  alt="back"
                />
              </li>
            ) : null}

            {pagination.map((element, index) => {
              let pageN = element + 1;
              return (
                <li
                  onClick={() => setPage(pageN)}
                  key={index}
                  className={pageN === currentPage ? "active" : null}
                >
                  <span>{pageN}</span>
                </li>
              );
            })}

            {currentPage < pagination.length ? (
              <li onClick={() => setPage(currentPage + 1)}>
                <img
                  loading="lazy"
                  src={globalFileIcon + "left-arrow.svg"}
                  alt="next"
                />
              </li>
            ) : null}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default UserHistory;
